import script from "./SellerLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./SellerLayout.vue?vue&type=script&setup=true&lang=ts"

import "./SellerLayout.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__